import { rem, shade, tint } from 'polished'
import styled from 'styled-components'

export const UploaderInputStyled = styled.div`
  display: flex;
  align-items: center;

  width: 100%;
  padding: ${rem(6)} ${rem(12)};
  background-color: ${(props) => tint(0.3, props.theme.colors.offwhite)};

  > * + * {
    margin-left: ${rem(12)};
  }

  > :last-child,
  > .last {
    margin-right: 0;
  }
`
